<template>
  <div>
    <Breadcrumb origin-name="Communities" origin-path="/communities" :additional-name="community.name" :additional-path="`/communities/${community.id}/community-manager`" current-name="Community Manager hinzufügen" />
    <h3>Community Manager hinzufügen</h3>
    <form @submit.prevent="submit">
      <div class="form-group">
        <label for="name-input">Vorname*</label>
        <input autofocus
               type="text"
               class="form-control"
               id="first-name-input"
               placeholder="Vorname"
               v-model="firstName"
               required />
      </div>
      <div class="form-group">
        <label for="name-input">Nachname*</label>
        <input type="text"
               class="form-control"
               id="last-name-input"
               placeholder="Nachname"
               v-model="lastName"
               required />
      </div>
      <div class="form-group">
        <label for="name-input">E-Mail*</label>
        <input type="text"
               class="form-control"
               id="email-input"
               placeholder="E-Mail"
               v-model="email"
               required />
      </div>
      <div class="hint mb-3">* Pflichtfelder</div>
      <button class="btn btn-primary" :class="{disabled: loading}">
        Einladen
        <span v-if="loading" class="spinner"></span>
      </button>
    </form>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";
import Breadcrumb from "@/components/partial/Breadcrumb.vue";

export default {
  components: {Breadcrumb},
  name: "AddCommunityManager",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      community: {},
      loading: false,
      deleteDialogVisible: false,
      disableDialogVisible: false,
      isNewOrganisation: false
    };
  },
  created() {
    if(this.$route.params.id) this.community = this.$store.state.communities.find(e => String(e.id) === this.$route.params.id);
  },
  methods: {
    onImageSelect(event) {
      if (event.target.files.length !== 1) return;
      this.image = event.target.files[0];
    },
    async submit() {
      if(this.loading) return;
      try {
        this.loading = true;
        const data = {
          affiliationId: this.community.id,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        };
        const response = await communicator.post("/communities/" + this.$route.params.id + "/community-manager", data);
        console.log("[AddCommunityManager] Got response: ", response);
        this.$router.push("/communities/" + this.$route.params.id + "/community-manager");
      } catch (e) {
        broadcast("error", e.response.data);
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>

</style>
